import { createApp } from "vue";
import FilterApp from './FilterApp.vue';
import { createPinia } from "pinia";
import { useFilterStore } from "./store";
import { updateHtml } from "../../components/pager";
import useFilterAPI from "./api";
import EventBus from "../../events/EventBus";
import { extractAppData } from "../../utils";
import { switchTabByCode } from "../../components/ajax_tabs";
import { initSetConstructor } from "../sets_constructor";
const filterEl = document.getElementById('filter-app');
const titleEl = document.querySelector('h1');
const constructorEl = filterEl?.querySelector('.constructor-set-box');
const notFoundMessage = document.getElementById('not-found-block');
function updateErrorMessage(show, isNew) {
    if (show) {
        notFoundMessage.querySelector('span[data-text-1]').innerText = isNew ? 'новых товаров' : 'товаров со скидкой';
        notFoundMessage.querySelector('span[data-text-2]').innerText = isNew ? 'новинки от других брендов' : 'самые популярные ароматы в нашей распродаже';
        notFoundMessage.classList.remove('hidden');
    }
    else {
        notFoundMessage.classList.add('hidden');
    }
}
function updatePageTitle(title) {
    if (title) {
        document.title = titleEl.innerText = title;
    }
}
export default async function initFilter() {
    const initialState = extractAppData(filterEl);
    if (!filterEl || !initialState) {
        return;
    }
    const html = document.querySelector('.catalog_items')?.innerHTML;
    const pagerHtml = document.querySelector('[data-pagination]')?.innerHTML;
    const title = titleEl.innerText;
    const pinia = createPinia();
    const store = useFilterStore(pinia);
    const api = useFilterAPI();
    const isConstructor = !!(constructorEl && initialState.setDraft);
    const setConstructorProps = isConstructor ? initSetConstructor(initialState.setDraft) : {};
    store.setInitialState(initialState);
    try {
        await api.request('/api/filter/state');
        store.setLoaded(false);
        createApp(FilterApp, {
            currentSort: document.getElementById('sorting')?.querySelector('.btn__label')?.textContent,
            ...setConstructorProps,
        }).use(pinia).mount(filterEl);
        store.setValues(initialState.values);
        store.updateValues();
        store.restoreExpandedStateFromSession();
        store.setLoaded();
        const state = { ...initialState, available: store.available, html, pagerHtml, title };
        window.history.replaceState(state, '', document.location.pathname + document.location.search);
    }
    catch (e) {
        console.error('Ошибка инициализации фильтра:', e);
    }
    EventBus.on('filter:page', (data) => {
        api.updateResults(false, { page: data.page, pager: true, loadMore: data.isMoreButton });
    });
    EventBus.on('tab:change', event => {
        const url = (store.sort.default !== store.sort.type ? `${event.url}?SORT=${store.sort.type}` : event.url);
        store.config.md = event.code;
        store.config.global = event.global;
        store.config.url = url;
        store.values = {};
        updatePageTitle(event.pageTitle);
        api.updateResults(true, { url, lockFilter: true })
            .then(function () {
            if (store.config.mode === 'BRAND') {
                updateErrorMessage(event.global, event.code === 'NEW');
            }
        });
    });
    window.addEventListener('popstate', (event) => {
        const { state } = event;
        if (!(state && state.config && state.values && state.page)) {
            return;
        }
        updatePageTitle(state.title);
        if ((state.config.md && store.config.md) && store.config.md !== state.config.md) {
            switchTabByCode(state.config.md, false);
        }
        store.setInitialState(state);
        store.setSortType(state.config.sort);
        store.updateAvailable(state.available || {});
        if (state.html) {
            updateHtml(state.html, false, state.pagerHtml);
        }
        else {
            api.updateResults(true, { page: state.page, pushState: false });
        }
    });
}
